function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20 0a20 20 0 100 40 20 20 0 000-40zm0 37.8a17.8 17.8 0 110-35.6 17.8 17.8 0 010 35.6zm-3.3-25.6c-.6 0-1.1.5-1.1 1.1v13.4a1.1 1.1 0 002.2 0V13.3a1.1 1.1 0 00-1.1-1zm5.5 1.1a1.1 1.1 0 012.2 0v13.4a1.1 1.1 0 01-2.2 0V13.3z"
});

function SvgOPause(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOPause);
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MCA0MCI+CiAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMCAwYTIwIDIwIDAgMTAwIDQwIDIwIDIwIDAgMDAwLTQwem0wIDM3LjhhMTcuOCAxNy44IDAgMTEwLTM1LjYgMTcuOCAxNy44IDAgMDEwIDM1LjZ6bS0zLjMtMjUuNmMtLjYgMC0xLjEuNS0xLjEgMS4xdjEzLjRhMS4xIDEuMSAwIDAwMi4yIDBWMTMuM2ExLjEgMS4xIDAgMDAtMS4xLTF6bTUuNSAxLjFhMS4xIDEuMSAwIDAxMi4yIDB2MTMuNGExLjEgMS4xIDAgMDEtMi4yIDBWMTMuM3oiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };